@if (tabs?.length) {
  <nav
    class="mb-2 flex w-min flex-nowrap items-center gap-3 border-b-2 border-french-blue-500"
    [class]="classOverrides"
    [class.!mb-0]="customStyle === 'insightsTabs'"
    [class.!gap-0]="customStyle === 'insightsTabs'"
  >
    @for (tab of tabs; track tab) {
      <button
        class="ag1-tab"
        [class]="{
          'rounded-t-md': customStyle === 'insightsTabs',
          'border-x': customStyle === 'insightsTabs',
          'border-t': customStyle === 'insightsTabs',
          'border-french-blue-100': customStyle === 'insightsTabs',
          'px-[6px]': customStyle === 'insightsTabs',
          'py-[2px]': customStyle === 'insightsTabs',
          'text-sm': customStyle === 'insightsTabs',
          'ag1-tab--active': tab?.toLowerCase() === activeTab?.toLowerCase(),
          'bg-french-blue-50':
            tab?.toLowerCase() === activeTab?.toLowerCase() &&
            customStyle === 'insightsTabs',
        }"
        (click)="onTabChanges(tab)"
        [disabled]="loading || disabledTabs?.includes(tab)"
      >
        {{ tab | sentenceCase }}
      </button>
    }
  </nav>
}
